import * as React from "react";

export const useToggleWithClickOutside = (
  ref: any,
  shouldCloseOnChildrenClick: boolean = false
) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const handleClickOutside = e => {
    if (
      ref &&
      ref.current &&
      // @ts-ignore
      ref.current.contains(e.target) &&
      !shouldCloseOnChildrenClick
    ) {
      return;
    }
    setIsOpen(false);
  };
  React.useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const toggle = (forceOpen?: boolean) =>
    setIsOpen(forceOpen ? forceOpen : !isOpen);

  return { isOpen, toggle } as const;
};
